<template>
  <div v-if="loading" class="d-flex align-center justify-center py-6">
    <v-progress-circular indeterminate color="primary" />
  </div>

  <router-view v-else />
</template>

<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "@/eventBus";

export default {
  name: "Audience",

  data() {
    return {
      loading: true,
    };
  },

  beforeMount() {
    eventBus.$on("entities:queue:reconnected", this.handleReconnectQueue);
    eventBus.$on("audiences:chat:reconnected", this.handleReconnectChat);

    setTimeout(() => {
      this.loading = false;
    }, 10000);
  },

  beforeDestroy() {
    eventBus.$off("entities:queue:reconnected", this.handleReconnectQueue);
    eventBus.$off("audiences:chat:reconnected", this.handleReconnectChat);
  },

  computed: {
    ...mapState("socket", ["audience", "socketSession"]),
  },

  methods: {
    ...mapActions("socket", [
      "setAudience",
      "audiencesChatJoin",
      "setAudienceMessage",
    ]),

    handleReconnectQueue(event) {
      const me = event.people.find(
        (el) => el.userID === this.socketSession?.userID
      );

      this.setAudience({
        ...(this.audience || {}),
        entityID: me?.entityID,
        ...event,
      });

      this.$router.push(
        { name: "QueueAudience" },
        () => {},
        () => {}
      );

      this.loading = false;
    },

    async handleReconnectChat(event) {
      const me = event.people.find(
        (el) => el.userID === this.socketSession?.userID
      );

      await this.audiencesChatJoin({
        data: me,
        callback: (error, data) => {
          if (error) {
            console.log("error audiences:chat:join", error);
            this.loading = false;
            return;
          }

          const meetLink = data.people.find(
            (el) => el.userID === this.socketSession?.userID
          )?.meet;

          this.setAudience({
            ...(this.audience || {}),
            entityID: me?.entityID,
            ...event,
            ...data,
            ...(meetLink && { meet: meetLink }),
          });

          if (data.messages?.length)
            this.setAudienceMessage(
              data.messages.map((el) => {
                const self = el.sender?.userID === this.socketSession?.userID;

                return {
                  ...el,
                  ...(self && { self, recipients: "self" }),
                };
              })
            );

          this.$router.push(
            { name: "ChatAudience" },
            () => {},
            () => {}
          );

          this.loading = false;
        },
      });
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
